export const SOCIAL_CODING_PROFILES = {
    LEETCODE: 'Leetcode',
    GITHUB: "Github",
    CODEFORCES: "CodeForces",
    LINKEDIN: "LinkedIn"
 }